// Based on BONESMidwayJavaScriptClient(https://code.amazon.com/packages/BONESMidwayJavaScriptClient/blobs/mainline/--/src/client.js)
// Differences are - 
// - this client supports specifying the API endpoint key to look for in the `settings.json` file - so that different clients can be created with different endpoints.
// - supports adding additional headers from `settings.json` which can be used in cases such as adding the API Key (header: x-api-key) to each request.

/* eslint no-prototype-builtins: "off",  no-console: "off",
          arrow-body-style: ["warn", "always"] */
import MidwayIdentityJavaScriptClient from 'midway-identity-java-script-client';

export default class CustomBONESMidwayJavaScriptClient {
  constructor(options) {
    this.makeClient = this.makeClient.bind(this);
    const opts = options || {};
    const s = this;

    const settingsFile = opts.settingsFile || 'settings.json'
    const alternateSettingsFile = `local-${settingsFile}`

    fetch(`/${settingsFile}`, {
      credentials: 'include',
    })
      .then((response) => {
        return response.json();
      })
      .then((settings) => {
        s.makeClient(settings, opts);
      })
      .catch(() => {
        console.log(`Trying ${alternateSettingsFile} instead`);
        fetch(`/${alternateSettingsFile}`)
          .then((response) => {
            return response.json();
          })
          .then((settings) => {
            s.makeClient(settings, opts);
          })
          .catch((err) => {
            if (opts.hasOwnProperty('onErr')) {
              opts.onErr(err);
            }
          });
      });
  }

  makeClient(settings, options) {
    let endpoint = settings.apiEndpoint;    
    if (!endpoint.startsWith('http')) {
      endpoint = `https://${endpoint}`;
    }

    const client = new MidwayIdentityJavaScriptClient({
      httpEndpoint: endpoint,
      cognitoIdentityPoolId: settings.cognitoPoolId,
      region: settings.region,
      headers: Object.assign({}, settings.additionalHeaders),
    });
    console.log('Client built from discovered settings.');
    this.client = client;
    if (options.hasOwnProperty('onReady')) {
      options.onReady(client);
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/custom-bones-midway-client.js